var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-row",
    [
      _c(
        "v-col",
        [
          _c(
            "v-row",
            { attrs: { justify: "center" } },
            [
              _c(
                "v-col",
                { staticClass: "text-center" },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        icon: "",
                        target: "_blank",
                        href: "https://twitter.com/daycohost"
                      }
                    },
                    [_c("v-icon", [_vm._v("mdi-twitter")])],
                    1
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        icon: "",
                        target: "_blank",
                        href: "https://www.instagram.com/daycohost/"
                      }
                    },
                    [_c("v-icon", [_vm._v("mdi-instagram")])],
                    1
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        icon: "",
                        target: "_blank",
                        href: "https://ve.linkedin.com/company/daycohost"
                      }
                    },
                    [_c("v-icon", [_vm._v("mdi-linkedin")])],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-row",
            {
              staticClass: "text-center white--text",
              attrs: { "no-gutters": "", justify: "center" }
            },
            [
              _c(
                "div",
                {
                  staticClass: "footer-info",
                  attrs: { title: _vm.appMetadata }
                },
                [
                  _vm._v(
                    " © " + _vm._s(_vm.currentDate) + ", Dayco Telecom, C.A. "
                  )
                ]
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }